import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import has from 'lodash/has';

const ObjectableType = styled.span`
 color: #5bc0de;
 font-weight: 700;
`;

class Create extends Component {
  callback = () => {
    const { activity, _pushCallback } = this.props;

    const projectId = has(activity, ['project_id']) ? activity.project_id : null;
    const objectableId = has(activity, ['objectable_id']) ? activity.objectable_id : null;
    const objectableType = has(activity, ['objectable_type']) ? activity.objectable_type : null;

    if (projectId && objectableId && objectableType) {
      _pushCallback(projectId, objectableId, objectableType);
    }
  }

  render() {
    const {
      activity,
    } = this.props;

    return (
      <span>
        <Link>
          {has(activity, ['user', 'first_name']) ? activity.user.first_name : ''}
          {' '}
          {has(activity, ['user', 'last_name']) ? activity.user.last_name : ''}
        </Link>
        {' '}
        created
        {' '}
        <ObjectableType>
          <Link onClick={this.callback} style={{ cursor: 'pointer' }}>
            {has(activity, ['data', 'next', 'name']) ? activity.data.next.name : ''}
          </Link>
        </ObjectableType>
      </span>
    );
  }
}

Create.propTypes = {
  activity: PropTypes.object,
  _pushCallback: PropTypes.func,
};

export default Create;



// WEBPACK FOOTER //
// ./src/components/ActivityFeed/ActivityTypes/Create.js